<template>
  <b-row>
    <b-col cols="12" class="d-flex align-items-center justify-content-between">
      <PageTitle title="Atualizar dados do ConstruBot" />
    </b-col>

    <b-col cols="12" class="mt-4" v-if="loading == false">
      <b-row>
        <b-col cols="12">

          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th scope="col">Número</th>
                <th scope="col">Nome</th>
                <th scope="col">Loja</th>
                <th scope="col">Cidade</th>
                <th scope="col" class="text-center">Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in data" :key="i">
                <td>{{formatarNumero(item.numero)}}</td>
                <td>{{item.nome != null ? item.nome : 'Sem nome'}}</td>
                <td>{{item.loja != null ? item.loja : 'Sem nome'}}</td>
                <td>{{item.cidade_uf != null ? item.cidade_uf : 'Sem nome'}}</td>
                <td class="text-center">
                  <button class="btn btn-danger" v-if="item.status == false" @click="upConstruBots(item.id)">
                    Desativar
                  </button>
                  <button class="btn btn-primary" v-if="item.status == true" @click="upConstruBots(item.id)">
                    Ativar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions } from 'vuex';
import PageTitle from 'Components/PageTitle.vue';
import makeToast from '@/mixins/makeToast';

export default {
  name:'ListConstruBotWhatsapp',
  mixins: [makeToast],

  components: {
    PageTitle
  },

  data() {
    return {
      loading: false,
      data: []
    };
  },

  created() {
    this.getConstruBots();
  },

   methods: {
    ...mapActions('admin', ['getConstrupWhatsApp', 'upConstrupWhatsApp']),
    getConstruBots() {
      this.loading = true;
      this.$store.dispatch('startLoader');
      this.getConstrupWhatsApp()
        .then((response) => {
          this.data = response.data;
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    upConstruBots(id) {
      this.loading = true;
      this.$store.dispatch('startLoader');
      this.upConstrupWhatsApp(id)
        .then(() => {
          this.getConstruBots();
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    formatarNumero(numero){
      if (numero.length === 13) {
        let codigoPais = numero.substr(0, 2);
        let codigoArea = numero.substr(2, 2);
        let primeiraParte = numero.substr(4, 1);
        let segundaParte = numero.substr(5, 4);
        let terceiraParte = numero.substr(9);

        return `+${codigoPais} (${codigoArea}) ${primeiraParte} ${segundaParte}-${terceiraParte}`;
      } else {
        let codigoPais = numero.substr(0, 2);
        let codigoArea = numero.substr(2, 2);
        let primeiraParte = numero.substr(4, 4);
        let segundaParte = numero.substr(8);

        return `+${codigoPais} (${codigoArea}) ${primeiraParte}-${segundaParte}`;
      }
    }
  },
}
</script>

<style>

</style>